import React from 'react'
import { connect } from 'react-redux'
import { getBillREQUEST } from '../../actions/BillActions'
import instagramLogo from '../../assets/instagram-logo.png'
import logo from '../../assets/logo_printable.png'
import websiteLogo from '../../assets/website-logo.png'
import '../../scss/bootstrap.scss'
import { isEmptyObject } from '../../utils/FunctionalUtils'
import { getNow, convertToJalaali } from '../utils/jalaaliUtils'
import { enToFa, priceToPersian } from '../utils/numberUtils'
import moment from 'moment-timezone';

const TOMAN = 'تومان'
const BORDER_BOTTOM = { borderBottom: '3px solid black' }

class PrintFactor extends React.Component {
  state = {
    receipt: {},
    bill: null,
  }
  
  getDatePart(value) {
    const closeDate = moment.utc(value);
    const iranCloseDate = closeDate.clone().tz('Asia/Tehran');
    return iranCloseDate.format('YYYY-MM-DD');
  }

  getTimePart(value){
    const closeDate = moment.utc(value);
    const iranCloseDate = closeDate.clone().tz('Asia/Tehran');
    return iranCloseDate.format('HH:mm:ss');
  }

  componentDidMount() {
    const params = this.props.match.params
    const resivedData = this.props.location.state
    console.log("res");
    if (
      (params.id && params.print === 'print') ||
      !(resivedData.pk === params.id && !isEmptyObject(resivedData))
    )
      this.props.getBillREQUEST(params.id).then((res) => {
        this.setState({ bill: res, receipt: res.items }, () => {
          if (params.print === 'print') {
            window.print()
          }
        })
      })
    else this.setState({ bill: resivedData, receipt: resivedData.items })
  }

  renderItems = () => {
    let final
    if (this.state.bill.items)
      final = this.state.bill.items.map((item, index) => {
        return (
          <div
            key={index}
            className="row border-black border-radius-7 mb-1 rtl text-right"
          >
            <p className="d-flex align-items-center justify-content-center col-1 text-center font-weight-bold border-left-3 m-0 p-2">
              {enToFa(index + 1)}
            </p>
            <p className="d-flex align-items-center justify-content-center col-3 text-center font-weight-bold border-left-3 m-0 py-0 px-0">
              <small className="w-100">
                <b>{enToFa(item.product.name)}</b>
                <hr class="m-0" style={BORDER_BOTTOM} />
                <b>{enToFa(item.product.code)}</b>
              </small>
            </p>
            <p className="d-flex align-items-center justify-content-center col text-center font-weight-bold border-left-3 m-0 p-2">
              {enToFa(item.amount)}
            </p>
            <p className="d-flex align-items-center justify-content-center col text-center font-weight-bold border-left-3 m-0 p-2">
              {enToFa(priceToPersian(parseInt(item.product.selling_price)))}
            </p>
            <p className="d-flex align-items-center justify-content-center col text-center font-weight-bold border-left-3 m-0 p-2">
              {enToFa(priceToPersian(item.discount))}
            </p>
            <p className="d-flex align-items-center justify-content-center col text-center font-weight-bold m-0 p-2">
              {enToFa(priceToPersian(parseInt(item.final_price)))}
            </p>
          </div>
        )
      })
    return final
  }

  render() {
    console.log(this.state.bill);
    return this.state.bill && (
      <div className="bootstrap factor">
        <div
          className="container rtl py-2"
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          <div style={{ width: '76mm' }}>
            <div className="row border-black border-radius-7 mb-2">
              <div className="col-12 d-flex align-items-center justify-content-center">
                <img src={logo} height="150" />
              </div>
            </div>
            <div className="row border-black border-radius-7 mb-2 rtl text-right p-2">
              <p className="col-3 font-weight-bold p-1">
                <span>شماره‌فاکتور:</span>
              </p>
              <p className="col-3 font-weight-bold p-1">
                <span>{enToFa(this.state.bill.bill_code)}</span>
              </p>

              <p className="col-3 font-weight-bold p-1 text-left">
                <span>فروشنده:</span>
              </p>
              <p className="col-3 font-weight-bold p-1">
                <span>
                  {this.state.bill.seller &&
                    this.state.bill.seller.first_name +
                      ' ' +
                      this.state.bill.seller.last_name}
                </span>
              </p>

              <p className="col-3 font-weight-bold p-1">
                <span>تاریخ فاکتور:</span>
              </p>
              <p className="col-3 font-weight-bold p-1">
                <span>{enToFa(convertToJalaali(this.getDatePart(this.state.bill.close_date)))}</span>
              </p>
              <p className="col-3 font-weight-bold p-1 text-left">
                <span>ساعت:</span>
              </p>
              <p className="col-3 font-weight-bold p-1">
                <span>{enToFa(this.getTimePart(this.state.bill.close_date))}</span>
              </p>

              <p className="col-3 font-weight-bold p-1">
                <span>کد مشترک:</span>
              </p>
              <p className="col-3 font-weight-bold p-1">
                <span>
                  {enToFa(
                    this.state.bill.buyer && this.state.bill.buyer.phone_number
                  )}
                </span>
              </p>

              <p className="col-3 font-weight-bold p-1 text-left">
                <span>صندوق:</span>
              </p>
              <p className="col-3 font-weight-bold p-1">
                <span>
                  {' '}
                  {this.state.bill.closande &&
                    this.state.bill.closande.first_name +
                      ' ' +
                      this.state.bill.closande.last_name}
                </span>
              </p>
            </div>
            <div className="row border-black border-radius-7 mb-1 rtl text-right">
              <p className="col-1 norm-latin text-center font-weight-bold border-left-3 m-0 py-2 px-0">
                <small>
                  <b>#</b>
                </small>
              </p>
              <p className="col-3 text-center font-weight-bold border-left-3 m-0 py-0 px-0">
                <small>
                  <b>شرح کالا</b>
                  <hr class="m-0" style={BORDER_BOTTOM} />
                  <b>کد کالا</b>
                </small>
              </p>
              <p className="d-flex justify-content-center align-items-center col text-center font-weight-bold border-left-3 m-0 py-2 px-0">
                <small>
                  <b>مقدار</b>
                </small>
              </p>
              <p className="d-flex justify-content-center align-items-center col text-center font-weight-bold border-left-3 m-0 py-2 px-0">
                <small>
                  <b>مبلغ‌واحد</b>
                </small>
              </p>
              <p className="d-flex justify-content-center align-items-center col text-center font-weight-bold border-left-3 m-0 py-2 px-0">
                <small>
                  <b>تخفیف</b>
                </small>
              </p>
              <p className="d-flex justify-content-center align-items-center col text-center font-weight-bold m-0 py-2 px-0">
                <small>
                  <b>مبلغ‌خالص</b>
                </small>
              </p>
            </div>
            {this.renderItems()}

            <div className="row-not-flex border-black border-radius-7 mb-1 rtl text-right">
              <div className="row border-bottom-3">
                <div className="col-6 font-weight-bold py-2 px-0 h5 text-left">
                  جمع کل:
                </div>
                <div className="col font-weight-bold p-2 h5 text-center">
                  {enToFa(priceToPersian(this.state.bill.price))}
                </div>
                <div className="col font-weight-bold p-2 h5 text-left">
                  {this.state.bill.price ? TOMAN : '-'}
                </div>
              </div>
              <div className="row border-bottom-3">
                <div className="col-6 font-weight-bold py-2 px-0 h5 text-left">
                  تخفیف کالایی:
                </div>
                <div className="col font-weight-bold p-2 h5 text-center">
                  {enToFa(priceToPersian(this.state.bill.items_discount))}
                </div>
                <div className="col font-weight-bold p-2 h5 text-left">
                  {this.state.bill.items_discount ? TOMAN : '-'}
                </div>
              </div>
              <div className="row border-bottom-3">
                <div className="col-6 font-weight-bold py-2 px-0 h5 text-left">
                  تخفیف فاکتوری:
                </div>
                <div className="col font-weight-bold p-2 h5 text-center">
                  {enToFa(
                    priceToPersian(
                      this.state.bill.total_discount -
                        this.state.bill.items_discount
                    )
                  )}
                </div>
                <div className="col font-weight-bold p-2 h5 text-left">
                  {this.state.bill.total_discount -
                  this.state.bill.items_discount
                    ? TOMAN
                    : '-'}
                </div>
              </div>
              <div className="row ">
                <div className="col-6 font-weight-bold py-2 px-0 h5 text-left">
                  مبلغ قابل پرداخت: 
                </div>
                <div className="col font-weight-bold p-2 h5 text-center">
                  {enToFa(priceToPersian(this.state.bill.final_price))}
                </div>
                <div className="col font-weight-bold p-2 h5 text-left">
                  {this.state.bill.final_price ? TOMAN : '-'}
                </div>
              </div>
            </div>
            <div className=" font-weight-bold p-2 row-not-flex border-black border-radius-7 mb-1 rtl text-right">
              {
                this.state.bill.branch.name == "bazar" && (
                  <p>
                    <span>آدرس: </span>
                    <span>
تهران، بازار بزرگ تهران، بازار کیلویی‌ها، پاساژ صدقیانی، طبقه اول، پلاک ۲۳، پارچه مدیلیش   
                    </span>
                    <span>
                      <br />
                    </span>
                    <span>تلفن: </span>
                    <span>۵۶۰۹۹۳۲۷</span>
                    <span>-</span>
                    <span>۰۲۱</span>
                  </p>
                )
              }

              {
                this.state.bill.branch.name == "gandy" && (
                  <p>
                    <span>آدرس: </span>
                    <span>
                        تهران، خیابان گاندی، بین خیابان ۲۳ و ۲۵، پلاک ۸۱، پارچه نفیس   
                    </span>
                    <span>
                      <br />
                    </span>
                    <span>تلفن: </span>
                    <span>۸۸۷۷۱۱۸۶</span>
                    <span>-</span>
                    <span>۰۲۱</span>
                  </p>
                )
              }
              
              <div className="row">
                {
                  this.state.bill.branch.name == "bazar" && (
                    <div
                      className="col col-8 text-left ltr d-flex norm-latin h4"
                      style={{ flexDirection: 'column' }}
                    >
                      <b>@modilish.ir</b>
                    </div>
                  )
                }

                {
                  this.state.bill.branch.name == "gandy" && (
                    <div
                      className="col col-8 text-left ltr d-flex norm-latin h4"
                      style={{ flexDirection: 'column' }}
                    >
                      <b>@nafisfabricstore</b>
                    </div>
                  )
                }
                
                <div className="col col-2 p-0 text-left">
                  <img src={instagramLogo} height="28" />
                </div>
              </div>
              <div className="row">
                <div
                  className="col col-8 text-left ltr d-flex norm-latin h4"
                  style={{ flexDirection: 'column' }}
                >
                  <b>Modilish.com</b>
                </div>
                <div className="col col-2 p-0 text-left">
                  <img src={websiteLogo} height="30" />
                </div>
              </div>
            </div>
            <div className=" p-2 row-not-flex border-black border-radius-7 mb-1 rtl text-right">
              <p className="text-center font-weight-bold">
                ممنون ازینکه ما رو برای خرید انتخاب کردید
              </p>
              <p className="text-center">
                <span>امیدواریم بزودی دوباره شما رو ببینیم</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

let mapStateToProps = (state) => {
  return {
    res: state,
  }
}

export default connect(mapStateToProps, { getBillREQUEST })(PrintFactor)
